/**
 * Distanza di tempo detta a parole.
 *
 * Nell'elenco la data di pubblicazione era sempre `DD/MM/YYYY HH:mm`: per
 * capire se un articolo fosse di stamattina o di tre settimane fa bisognava
 * leggere le cifre e fare il conto. Oltre il mese la data esatta torna a dire
 * di piu' di "45 giorni fa", quindi si torna al formato pieno.
 *
 * `secondi` e' un timestamp in secondi, come lo manda il backend.
 */
export function tempoRelativo(
  secondi: number | null | undefined,
  adessoInSecondi: number = Math.floor(Date.now() / 1000)
): string {
  if (!secondi) return '';

  const differenza = adessoInSecondi - secondi;
  const futuro = differenza < 0;
  const distanza = Math.abs(differenza);

  if (distanza < 60) return 'adesso';

  const minuti = Math.floor(distanza / 60);
  if (minuti < 60) return componi(minuti, 'minuto', 'minuti', futuro);

  const ore = Math.floor(distanza / 3600);
  if (ore < 24) return componi(ore, 'ora', 'ore', futuro);

  const giorni = Math.floor(distanza / 86400);
  if (giorni === 1) return futuro ? 'domani' : 'ieri';
  if (giorni <= 30) return componi(giorni, 'giorno', 'giorni', futuro);

  return dataPiena(secondi);
}

function componi(quantita: number, singolare: string, plurale: string, futuro: boolean): string {
  const unita = quantita === 1 ? singolare : plurale;
  return futuro ? `tra ${quantita} ${unita}` : `${quantita} ${unita} fa`;
}

/** Data completa, per il tooltip e per le date lontane. */
export function dataPiena(secondi: number | null | undefined): string {
  if (!secondi) return '';
  const data = new Date(secondi * 1000);
  const due = (n: number) => String(n).padStart(2, '0');
  return `${due(data.getDate())}/${due(data.getMonth() + 1)}/${data.getFullYear()}`;
}

/** Data e ora complete, per il tooltip sulla colonna della data. */
export function dataOraPiena(secondi: number | null | undefined): string {
  if (!secondi) return '';
  const data = new Date(secondi * 1000);
  const due = (n: number) => String(n).padStart(2, '0');
  return `${due(data.getDate())}/${due(data.getMonth() + 1)}/${data.getFullYear()} ${due(data.getHours())}:${due(data.getMinutes())}`;
}
